/* src/app/pages/ui-kit/components/table-view/table-view.component.scss */
.card-grouped {
  padding: 16px;
  border-radius: 16px;
  background-color: var(--contrast-inverse);
  border: 1px solid var(--secondary-subtle-hover);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}
/*# sourceMappingURL=table-view.component.css.map */
